module.exports = __webpack_public_path__ + "static/media/header-logo2.8a62b0e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header-logo2.svg
// module id = 902
// module chunks = 0